<template>
  <div class="dashboard-container">
    <!--项目信息-->
    <div class="wrap-top">
      <el-row>
        <el-col :span="12">
          <h3>
            项目信息：
            <span v-if="status === '项目已锁定'" style="color: red"
              >{{ status }} <i class="el-icon-lock" style="margin-left: 5px"></i
            ></span>
            <span v-else-if="status === '项目进行中'" style="color: #52c41a"
              >{{ status
              }}<i class="el-icon-s-flag" style="margin-left: 5px"></i
            ></span>
            <span v-else style="color: #597ef7"
              >{{ status }}<i class="el-icon-edit" style="margin-left: 5px"></i
            ></span>
          </h3>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <template v-if="activeENV === 'UAT'">
            <el-button
              v-if="roles.includes('项目管理发布到PROD') || is_manager"
              :disabled="projectInfo.is_public_prod"
              type="primary"
              size="mini"
              @click="publishToPROD"
              >发布到PROD
            </el-button>
          </template>
          <el-button
            v-if="isShowBtn"
            type="primary"
            size="mini"
            v-preventReClick
            @click="handleStart"
            >{{ text }}
          </el-button>
        </el-col>
      </el-row>
      <div class="proInfo">
        <el-row class="item">
          <el-col :span="11">项目名称：{{ name }}</el-col>
          <el-col :span="1" style="opacity: 0">1</el-col>
          <el-col :span="12">
            开始时间：
            <el-date-picker
              size="mini"
              v-model="start_time"
              @change="blurFb()"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="11">项目简称：{{ short_name }}</el-col>
          <el-col :span="1" style="opacity: 0">1</el-col>
          <el-col :span="12"
            >有效时间：
            <el-input
              @blur="blurFb()"
              style="width: 220px"
              v-model="effective_month"
              size="mini"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            />
            个月
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="12">申办方：{{ sponsor }}</el-col>
          <el-col :span="12"
            >研究领域：
            <el-select
              @change="blurFb()"
              style="width: 220px"
              size="mini"
              v-model="research_field"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="item">
          <el-col :span="12">临床试验方案号：{{ clinical_trials_code }}</el-col>
          <el-col :span="8">样本量： {{ sample_size }}</el-col>
        </el-row>
      </div>
    </div>
    <!--图例-->
    <div v-permission="['项目首页可视化界面']" class="wrap-bottom">
      <!--左：中心-->
      <div class="left">
        <div class="center-left">
          <h3>各中心入组例数</h3>
          <div class="progress_box">
            <div
              class="progress_row"
              v-for="(unit, index) in statisticsData.unit_res"
              :key="index"
            >
              <div>{{ `[${unit.code}]${unit.name}` }}</div>
              <my-progress
                :fontcolor="'#85A5FF'"
                :height="20"
                color="#D6E4FF"
                :totalFontColor="'#8C8C8C'"
                :number="unit.now_num"
                :total="unit.num ? unit.num : unit.now_num"
                :border="'1px solid #ADC6FF'"
              ></my-progress>
            </div>
          </div>
        </div>
        <div class="center-left" v-if="layerRes.length">
          <h3>分层例数</h3>
          <div></div>
          <div
            class="progress_box"
            style="margin-bottom: 50px"
            v-for="(item, index) in layerRes"
            :key="index"
          >
            <div style="font-size: 16px">{{ item.name }}：</div>
            <div
              v-for="(item1, index1) in item.son_list"
              class="progress_row"
              :key="index1"
            >
              <div>
                {{ item1.name }}
              </div>
              <my-progress
                :fontcolor="'#85A5FF'"
                :height="20"
                color="#D6E4FF"
                :totalFontColor="'#8C8C8C'"
                :number="item1.now_num"
                :total="item1.num ? item1.num : item1.now_num"
                :border="'1px solid #ADC6FF'"
                :width="468"
              ></my-progress>
            </div>
          </div>
        </div>
      </div>
      <!--右：分层-->
      <div class="right">
        <div class="chart_box">
          <template v-if="this.unitChartData.rows.length">
            <ve-pie
              :data="unitChartData"
              height="300px"
              :legend-visible="false"
              :tooltip="tooltip"
              :settings="chartSettings"
              log
            ></ve-pie>
            <div class="chart_detail">
              <span>{{ proId === "678f3c9def2164132767c5c8"?'随机人数':'入组人数' }}</span>
              <svg-icon
                icon-class="open_chart"
                @click="showChart('入组人数')"
              />
            </div>
          </template>

          <el-empty v-else description="暂无数据"></el-empty>
        </div>
        <div class="chart_box">
          <template v-if="this.subjectChartData.rows.length">
            <ve-pie
              :data="subjectChartData"
              height="300px"
              :legend-visible="false"
              :settings="chartSettings"
              resizeable
            ></ve-pie>
            <div class="chart_detail">
              <span>受试者状态</span>
              <svg-icon
                icon-class="open_chart"
                @click="showChart('受试者状态')"
              />
            </div>
          </template>
          <el-empty v-else description="暂无数据"></el-empty>
        </div>

        <div class="chart_box" v-for="(item, index) in layer_res" :key="index">
          <ve-pie
            :data="item"
            height="300px"
            :legend-visible="false"
            :settings="chartSettings"
            resizeable
          ></ve-pie>
          <div class="chart_detail">
            <span>{{ item.name }}</span>
            <svg-icon icon-class="open_chart" @click="showChart(item)" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="echartDialogVisible"
      width="75%"
      :close-on-click-modal="false"
      @close="echartDialogVisible = false"
      center
      class="export"
    >
      <div ref="myChart" style="width: 100%; height: 60vh"></div>
    </el-dialog>
  </div>
</template>

<script>
import echarts from "echarts";
import {
  detailPro,
  start,
  statistics,
  lockingPro,
  updatePro,
  unLockingPro,
} from "@/api/homePage";
import { publishPROD } from "@/api/project";
import { getProjectId, setProStatus } from "@/utils/auth";
import checkPermission from "@/utils/permission"; // 权限判断函数
import MyProgress from "./component/my_progress";

export default {
  name: "Homepage",
  components: {
    MyProgress,
  },
  data() {
    this.chartSettings = {
      label: {
        formatter: "{@data}",
      },
      offsetY: 150,
    };
    this.tooltip = {
      formatter: "{b}:{c}",
    };
    return {
      echartDialogVisible: false,
      unitChartData: {
        columns: ["name", "data"],
        rows: [],
      },
      subjectChartData: {
        columns: ["name", "data"],
        rows: [],
      },
      drawer: false,
      proId: "",
      short_name: "",
      name: "",
      start_time: "",
      effective_month: "",
      sponsor_name: "",
      research_field: "",
      sponsor: "",
      sample_size: "",
      clinical_trials_code: "",
      status: "",
      text: "启动项目",
      // 中心
      centerData: [],
      centerUnit: [],
      dataCost: [],
      visits: [],
      isShowBtn: false, // 项目锁定隐藏按钮
      proStatus: "", // 项目状态
      layerRes: [], // 分层例数
      statisticsData: {},
      roles: this.$store.getters.roles,
      is_manager: this.$store.getters.isAdmin,
      activeENV: sessionStorage.getItem("iwrs_environment") || "UAT",
      detailData: null,
      options: [
        {
          value: "其他",
          label: "其他",
        },
        {
          value: "创伤/急救药",
          label: "创伤/急救药",
        },
        {
          value: "风湿免疫科",
          label: "风湿免疫科",
        },
        {
          value: "精神病学/心理学",
          label: "精神病学/心理学",
        },
        {
          value: "药理学/毒理学",
          label: "药理学/毒理学",
        },
        {
          value: "儿科/新生儿",
          label: "儿科/新生儿",
        },
        {
          value: "耳鼻喉科",
          label: "耳鼻喉科",
        },
        {
          value: "眼科",
          label: "眼科",
        },
        {
          value: "肿瘤科",
          label: "肿瘤科",
        },
        {
          value: "妇产/妇科",
          label: "妇产/妇科",
        },
        {
          value: "神经内科",
          label: "神经内科",
        },
        {
          value: "肾脏医学/泌尿外科",
          label: "肾脏医学/泌尿外科",
        },
        {
          value: "肌肉骨骼系统",
          label: "肌肉骨骼系统",
        },
        {
          value: "免疫学/传染病",
          label: "免疫学/传染病",
        },
        {
          value: "胃肠病科",
          label: "胃肠病科",
        },
        {
          value: "内分泌科",
          label: "内分泌科",
        },
        {
          value: "其他医疗器械",
          label: "其他医疗器械",
        },
        {
          value: "皮肤科/整形手术",
          label: "皮肤科/整形手术",
        },
        {
          value: "牙科/颌面外科",
          label: "牙科/颌面外科",
        },
        {
          value: "中枢神经系统",
          label: "中枢神经系统",
        },
        {
          value: "心血管医疗器械",
          label: "心血管医疗器械",
        },
        {
          value: "心脏病/血管疾病",
          label: "心脏病/血管疾病",
        },
        {
          value: "不适用",
          label: "不适用",
        },
      ],
      projectInfo: {},
      layer_res: [],
    };
  },
  created() {
    this.proId = getProjectId();
    this.getDetailPro();
  },
  mounted() {
    if (checkPermission(["项目首页可视化界面"])) {
      this.$nextTick(() => {
        this.getStatistics();
      });
    }
  },
  methods: {
    getEchartData(data) {
      const chart = this.$refs.myChart;
      if (chart) {
        const myChart = this.$echarts.init(chart);
        const option = {
          title: {
            text: data.name,
            subtext: "无数据项图表内暂无显示",
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}:{c}",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 80,
            bottom: 20,
            data: data.legendData,
          },
          series: [
            {
              type: "pie",
              radius: "65%",
              center: ["40%", "50%"],
              selectedMode: "multiple",
              stillShowZeroSum: true,
              data: data.seriesData,
              label: {
                normal: {
                  formatter: function (e) {
                    let data = e.data;
                    if (data.value == 0) {
                      data.labelLine.show = false;
                      data.label.show = false;
                    } else {
                      return `${data.name}\n${data.value}(${e.percent}%)`;
                    }
                  },
                },
              },
            },
          ],
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    //显示详情echart
    showChart(val) {
      switch (val) {
        case "入组人数":
          this.echartDialogVisible = true;
          setTimeout(() => {
            this.getEchartData({
              name: this.proId === '678f3c9def2164132767c5c8'? "随机人数": "入组人数",
              legendData: this.statisticsData.unit_res.map((i) => {
                return {
                  name: `[${i.code}]${i.name}`,
                  icon: "circle",
                };
              }),
              seriesData: this.statisticsData.unit_res.map((i) => {
                return {
                  value: i.data,
                  name: `[${i.code}]${i.name}`,
                  labelLine: {
                    show: true,
                  },
                  label: {
                    show: true,
                  },
                };
              }),
            });
          }, 0);
          break;

        case "受试者状态":
          this.echartDialogVisible = true;
          setTimeout(() => {
            this.getEchartData({
              name: "受试者状态",
              legendData: this.statisticsData.subject_res.map((i) => {
                return {
                  name: i.name,
                  icon: "circle",
                };
              }),
              seriesData: this.statisticsData.subject_res.map((i) => {
                return {
                  value: i.data,
                  name: i.name,
                  labelLine: {
                    show: true,
                  },
                  label: {
                    show: true,
                  },
                };
              }),
            });
          }, 0);
          break;

        default:
          this.echartDialogVisible = true;
          setTimeout(() => {
            this.getEchartData({
              name: val.name,
              legendData: val.rows.map((i) => {
                return {
                  name: i.name,
                  icon: "circle",
                };
              }),
              seriesData: val.rows.map((i) => {
                return {
                  value: i.data,
                  name: i.name,
                  labelLine: {
                    show: true,
                  },
                  label: {
                    show: true,
                  },
                };
              }),
            });
          }, 0);
          break;
      }
    },
    publishToPROD() {
      this.$confirm("确认要发布到PROD吗？", "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning",
      })
        .then(() => {
          publishPROD({
            project_id: this.proId,
          }).then((res) => {
            if (res && res.code === 0) {
              this.$message.success(res.msg);
              this.getDetailPro();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    format(now_num) {
      console.log(now_num);
      return (p) => {
        console.log(p);
        return now_num;
      };
    },
    getDetailPro() {
      detailPro({ id: this.proId }).then((res) => {
        if (res && res.code === 0) {
          setProStatus(res.data.status);
          this.detailData = res.data;
          this.detailData.sponsor = res.data.sponsor_name;
          this.status = res.data.status;
          this.projectInfo = res.data;
          if (
            this.status === "项目创建中" &&
            (this.is_manager || this.roles.indexOf("项目管理启动项目") > -1)
          ) {
            this.text = "启动项目";
            this.isShowBtn = true;
          } else if (
            this.status === "项目进行中" &&
            (this.is_manager || this.roles.indexOf("项目管理锁定项目") > -1)
          ) {
            this.text = "锁定项目";
            this.isShowBtn = true;
          } else if (this.status === "项目已锁定") {
            this.text = "解锁项目";
            this.isShowBtn = true;
          }
          this.short_name = res.data.short_name;
          this.start_time = res.data.start_time;
          this.name = res.data.name;
          this.effective_month = res.data.effective_month;
          this.sponsor_name = res.data.sponsor_name;
          this.research_field = res.data.research_field;
          this.sponsor = res.data.sponsor_name;
          this.sample_size = res.data.sample_size;
          this.clinical_trials_code = res.data.clinical_trials_code;
        }
      });
    },
    // 可视化
    getStatistics() {
      statistics({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            this.statisticsData = res.data;
            this.dataHandel(res.data);
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    dataHandel(data) {
      const { layer_res, subject_res, unit_res } = data;
      let arr = [];
      unit_res.forEach((i) => {
        if (i.data) {
          arr.push({
            name: `[${i.code}]${i.name}`,
            data: i.data,
          });
        }
      });
      //过滤掉为0的空数据
      this.unitChartData.rows = arr;
      // console.log(this.unitChartData.rows);
      this.subjectChartData.rows = subject_res.filter((i) => {
        return i.data !== 0;
      });
      this.layer_res = layer_res.map((i) => {
        return {
          name: i.name,
          columns: ["name", "data"],
          rows: i.son_list,
        };
      });
      this.layerRes = layer_res;
      // // 图表1
      // const drawPieChart1 = [];
      // data.unit_res.map((item) => {
      //   const obj = {};
      //   obj.name = item.name;
      //   obj.value = item.now_num;
      //   drawPieChart1.push(obj);
      // });
      // this.layerRes = data.layer_res;

      // // 饼图入组
      // this.drawPieChart1(drawPieChart1);
      // // 饼图受试者状态
      // this.drawPieChart2(data.subject_res);
      // // 分层饼图
      // this.$nextTick(() => {
      //   this.drawPieChartAll(data.layer_res);
      // });
    },
    // 启动项目
    handleStart() {
      if (this.status === "项目创建中") {
        this.$confirm("确认要启动该项目吗？", "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          type: "warning",
        })
          .then(() => {
            this.startPro();
          })
          .catch(() => {});
      } else if (this.status === "项目进行中") {
        this.$confirm("确认要锁定该项目吗？", "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          type: "warning",
        })
          .then(() => {
            this.locking();
          })
          .catch(() => {});
      } else {
        this.$confirm(`确认要解锁该项目吗？`, "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          type: "warning",
        })
          .then(() => {
            this.unlocking();
          })
          .catch(() => {});
      }
    },
    // 启动项目
    startPro() {
      start({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            this.getDetailPro();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 锁定项目
    locking() {
      lockingPro({ id: this.proId })
        .then((res) => {
          console.log(res);
          if (res && res.success) {
            this.getDetailPro();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    //解锁项目
    unlocking() {
      unLockingPro({ id: this.proId })
        .then((res) => {
          if (res && res.success) {
            this.getDetailPro();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    blurFb() {
      // console.log(this.detailData)
      // console.log(this.start_time)
      this.detailData.start_time = this.start_time;
      this.detailData.effective_month = this.effective_month;
      this.detailData.research_field = this.research_field;
      updatePro(this.detailData).finally(()=> {
        this.getDetailPro();
      })
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  height: 30px;
}
.wrap {
  width: 100%;
  height: 100%;
  /*border: 1px solid red;*/
}

.wrap-top {
  padding-bottom: 20px;
  /* border-bottom: 1px solid #adc6ff; */
}

.proInfo {
  width: 96%;
  margin: 0 auto;
  font-weight: bold;
}

.item {
  padding-bottom: 15px;
}

.wrap-bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* margin-top: 20px; */
  border-top: 15px solid #f2f5f7;
}

.left {
  width: 45%;
  /*border: 1px solid red;*/
  height: 100%;
}
.right {
  width: 55%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.right .chart_box {
  height: 340px;
  width: 50%;
  border-bottom: 15px solid #f2f5f7;
}
.right .chart_box:nth-child(odd) {
  border-left: 15px solid #f2f5f7;
  border-right: 15px solid #f2f5f7;
}
.chart_detail {
  position: relative;
  text-align: center;
  height: 25px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #595959;
  padding-bottom: 10px;
}
.chart_detail .svg-icon {
  position: absolute;
  right: 15px;
  cursor: pointer;
}

.left {
  height: 30%;
}

.num {
  padding-left: 20px;
}

.center-left {
  height: 340px;
  /* box-sizing: border-bo; */
  border-bottom: 15px solid #f2f5f7;
  overflow: auto;
}
.center-left h3 {
  margin: 0;
  padding: 15px 0;
}
.center-left .progress_box {
  padding: 0 3vw;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #595959;
}
.progress_row {
  margin-top: 18px;
}

.right-top,
.right-bottom {
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: space-between;
}

.btn-custom-cancel {
  /* float: right; */
  margin-left: 10px;
}

/deep/ .el-message-box__wrapper .el-message-box .el-message-box__btns {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
</style>
